import React from "react";
import FormLine from "../../Misc/FormLine";
import SuperSelect from "../../Misc/SuperSelect";
import DocumentPicker from "../../Misc/DocumentPicker";
export default class DeliveryHat extends React.Component {
  render() {
    const item = this.props.item || {};
    return (
      <div className="row">
        {item.classcode === "waybill" && (
          <>
            <div className="col-12 mb-3">
              <FormLine label="Получатель:">
                <SuperSelect
                  defaultValue={item.receiver}
                  onChange={(value) => this.props.onChange("receiver", value)}
                  essence="client"
                  placeholder="Выберите..."
                  nameField="label"
                  idField="id"
                />
              </FormLine>
            </div>
          </>
        )}
        <div className="col">
          <FormLine label="Основание:">
            <DocumentPicker
              classes={["waybill", "order", "cancellation", "installation"]}
              states={["disabled"]}
              defaultValue={item.parent}
              onChange={(value) => this.props.onChange("parent", value)}
            />
          </FormLine>
        </div>
        <div className="col">
          <FormLine label="Комментарий:">
            <input
              type="text"
              value={item.description || ""}
              onChange={(e) =>
                this.props.onChange("description", e.target.value)
              }
              className="form-control"
            />
          </FormLine>
        </div>
      </div>
    );
  }
}
